module.exports = __webpack_public_path__ + "img/icon-usuario.15e79225.svg";